import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { CommonFunction } from '../../common-function';
import { ProjectConstants } from '../../project-constants';

@Component({
  selector: 'app-viewattachment',
  templateUrl: './viewattachment.component.html',
  styleUrls: ['./viewattachment.component.scss'],
})
export class ViewattachmentComponent implements OnInit {
  imageSrc: string = "";
  showImg: boolean = false;
  imageUrl: any;
  progressSpinnerDialog: any = null;
  constructor(public dialogRef: MatDialogRef<ViewattachmentComponent>,
    public domSanitizer: DomSanitizer,
    public commonFunction:CommonFunction,
     public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {

    if (this.data[2] == "application/pdf") {
      this.showImg = false
      const byteArray = new Uint8Array(
        atob(this.data[0])
          .split("")
          .map((char) => char.charCodeAt(0))
      );
      let blob = new Blob([byteArray], { type: this.data[2] });
      var pdfSrc = URL.createObjectURL(blob);
    } else {
      const byteArray = new Uint8Array(
        atob(this.data[0])
          .split("")
          .map((char) => char.charCodeAt(0))
      );

      let blob = new Blob([byteArray], { type: this.data[2] });
      var pdfSrc = URL.createObjectURL(blob);
      this.imageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(pdfSrc);
      this.showImg = true;
    }
    //
  }

  //download attachement when click on download btn
 async downloadAttach() {
    this.displayProgressSpinner();
    const byteArray = new Uint8Array(
      atob(this.data[0])
        .split("")
        .map((char) => char.charCodeAt(0))
    );
    let blob = new Blob([byteArray], { type: this.data[2] });
    var src = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = src;
    // link.download = this.data[1];
    const date = new Date().toDateString(),
    time = new Date().getTime()
    link.download = this.data[1]+ "_" +date+"_"+time+
    '.' + this.data[3].split('.').pop();
    link.click();
    this.progressSpinnerDialog.close();
    // this.fileSuccessToast()
    await this.commonFunction.successToast(ProjectConstants.fileSuccessToastMsg,false,"")
  }
  //

  // async fileSuccessToast() {
  //   await this._snackBar.open(
  //     "File downloaded successfully",
  //     "Close", {
  //     horizontalPosition: "right",
  //     verticalPosition: "top",
  //     panelClass: "success-toast",
  //     duration: 3 * 1000,
  //   }
  //   );
  // }

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }
}
